module.exports = __webpack_public_path__ + "static/img/qudi (8).e33d99d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qudi/qudi (8).jpg
// module id = uB72
// module chunks = 0